// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WI-yl","select":"styles_select__3limG"};